import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>TekRevol’s Tech Stack for Building Rich Feature Mobile Apps in Qatar</h2>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
            We are committed to ongoing advancements in mobile app development to maintain a competitive edge in the market. To achieve this, we enhance our app development process by embracing emerging technologies. Our expert app developers in Qatar have specialized in multiple technologies and they utilize the suitable stack to your project requirements. Here’s the stack that we usually deploy in our app development:
            </p>
          </Col>
        </Row>
        <Row>
        <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Mobile Frontend">
              <ul>
                <li>React Native</li>
                <li>Flutter</li>
                <li>Swift (iOS)</li>
                <li>Kotlin (Android)</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="SDKs/Tools/Framework">
              <ul>
                <li>Firebase</li>
                <li>Redux</li>
                <li>Alamofire (iOS)</li>
                <li>Retrofit (Android)</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Operating System">
              <ul>
                <li>iOS</li>
                <li>Android</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Platforms">
              <ul>
                <li>App Store (iOS)</li>
                <li>Google Play (Android)</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Others">
              <ul>
                <li>Git</li>
                <li>RESTful APIs</li>
                <li>JSON</li>
                <li>Gradle (Android)</li>
                <li>Xcode (iOS)</li>
                <li> Android Studio (Android)</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
